// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Advertise from './pages/Advertise';
import Society from './pages/Society';
import Politics from './pages/Politics';
import Culture from './pages/Culture';
import Sports from './pages/Sports';
import Incidents from './pages/Incidents';
import Education from './pages/Education';
import NewsArticle from './pages/NewsArticle';

function App() {
  return (
    <>
      <Navbar />
      {/* Основное содержимое страницы с отступом сверху для navbar */}
      <div className="pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/advertise" element={<Advertise />} />
          <Route path="/society" element={<Society />} />
          <Route path="/politics" element={<Politics />} />
          <Route path="/culture" element={<Culture />} />
          <Route path="/sports" element={<Sports />} />
          <Route path="/incidents" element={<Incidents />} />
          <Route path="/education" element={<Education />} />
          <Route path="/news/:id" element={<NewsArticle />} />
          {/* Добавьте остальные маршруты по мере необходимости */}
        </Routes>
      </div>
    </>
  );
}

export default App;
